// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"13e596b9","171":"da4d6e17","453":"c0c57d4d","764":"f9429871"}[chunkId] + ".chunk.js";
};